import { Component, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

import { ConciergeApiService } from 'src/shared/services/concierge-api.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';

@Component({
    selector: 'add-inspections-onboarding',
    templateUrl: './add-inspections-onboarding.html',
    styleUrls: ['./add-inspections-onboarding.scss'],
    standalone: false
})
export class AddInspectionsOnboardingComponent {

  inspectionTemplates = [
    {
      name: '',
      description: 'In-Person Inspection',
      isSelected: false
    },
    {
      name: '',
      description: 'Virtual Inspection',
      isSelected: false
    },
    {
      name: '',
      description: 'No Inspection',
      isSelected: false
    },
  ];

  boundSave = this.save.bind(this);

  private readonly conciergeApi = inject(ConciergeApiService);
  private readonly util = inject(Util);
  readonly onboardingProvider = inject(OnboardingProvider);
  private readonly rightSidePanelService = inject(RightSidePanelService);
  public readonly windowService = inject(WindowService);

  constructor() {}

  async save() {
    const selectedTemplate = this.inspectionTemplates.find(t => t.isSelected);
    const data = {
      subject: 'Inspection Settings',
      body: selectedTemplate.description,
      emails: [],
      attachments: [],
    }
    const item = {
      data,
      type: 'support.concierge_task',
    }
    try {
      await Promise.all([
        lastValueFrom(this.conciergeApi.createConciergeItem(item)),
        this.onboardingProvider.markGoalAsCompleted('addInspections')
      ]);
      this.rightSidePanelService.setDialogPageTitle('Getting Started');
      this.rightSidePanelService.navigateTo('onboarding', {}, OnboardingComponent);
      this.onboardingProvider.setShowOnboardingInHeader(true);
      this.util.showSuccess('Inspection settings saved');
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  selectTemplate(template) {
    template.isSelected = !template.isSelected;
    this.inspectionTemplates.forEach(t => {
      if (t !== template) {
        t.isSelected = false;
      }
    });
  }
}
